import { storageAdminService } from "../../services/storageAdmin";
import { ActionTypes } from "../constants/actionTypes";
import { alertError } from "./alertActions";

export const storageAdminActions = {
    getPrimariesForApplication,
    getSecondoriesForApplication,
};

function getPrimariesForApplication(access, application_id) {
    return (dispatch) => {
        dispatch(request({}));
        storageAdminService.getPrimaries(access, application_id).then((Primaries) => {
            dispatch(success(Primaries))
        }).catch((err) => {
            console.error(err)
            dispatch(failure(err))
            dispatch(alertError(err))
        })
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_APPLICATION_PRIMARY_REQUEST, user };
    }
    function success(storage_admin_primaries) {
        return { type: ActionTypes.ADMIN_APPLICATION_PRIMARY_SUCCESS, storage_admin_primaries };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_APPLICATION_PRIMARY_SUCCESS, error };
    }
}

function getSecondoriesForApplication(access, applicaiton_id) {
    return (dispatch) => {
        dispatch(request({}));
        storageAdminService.getLevel2ForApplication(access, applicaiton_id)
            .then((Secondaries) => {
                dispatch(success(Secondaries));
            })
            .catch((err) => {
                console.error(err);
                dispatch(failure(err));
                dispatch(alertError(err));
            });
    };
    function request(user) {
        return { type: ActionTypes.ADMIN_APPLICATION_SECONDARY_REQUEST, user };
    }
    function success(storage_admin_secondaries) {
        return { type: ActionTypes.ADMIN_APPLICATION_SECONDARY_SUCCESS, storage_admin_secondaries };
    }
    function failure(error) {
        return { type: ActionTypes.ADMIN_APPLICATION_SECONDARY_FAILURE, error };
    }
}